import { InputAdornment } from 'ui';

import { TextField } from '../../index';
import { PriceAsIndexFixPriceAtField } from '../PriceAsIndexFixPriceAtField/PriceAsIndexFixPriceAtField';
import { PriceAsIndexWhenToFixField } from '../PriceAsIndexWhenToFixField/PriceAsIndexWhenToFix';
import { PriceIndexField } from '../PriceIndexField/PriceIndexField';

type Props = {
  size?: 'small' | 'medium' | undefined;
};

export const PriceAsIndex = ({ size = 'small' }: Props) => {
  return (
    <>
      <PriceIndexField label="Price index" name="price_index" size={size} />
      <TextField
        name="price_as_index_percentage"
        label="Percentage to fix"
        size={size}
        type="number"
        InputProps={{
          endAdornment: <InputAdornment position="end">%</InputAdornment>,
        }}
      />
      <PriceAsIndexWhenToFixField label="When to fix" name="price_as_index_percentage_fixed_on_date" size={size} />
      <PriceAsIndexFixPriceAtField label="Fix price at" name="price_as_index_percentage_fixed_on" size={size} />
    </>
  );
};
